export const copy2DArrayToClipboard = (array: string) => {
    var csv = '', row, cell;
    Object.keys(array[0]).forEach((cell, index) => {
      csv += (cell+'').replace(/[\n\t]+/g, ' ');
      if (index+1 < Object.keys(array[0]).length) csv += '\t';
    });
    csv += '\n';
    for (row = 0; row < array.length; row++) {
      Object.keys(array[row]).forEach((cell, index) => {
        csv += (array[row][cell]+'').replace(/[\n\t]+/g, ' ');
        if (index+1 < Object.keys(array[row]).length) csv += '\t';
      });
      if (row+1 < array.length) csv += '\n';
    }
    return csv;
};

